export const preventDefault = e => {
  e = e || window.event;
  if (e.preventDefault) e.preventDefault();
  e.returnValue = false;
};

export const preventDefaultForScrollKeys = e => {
  const keys = { 7: 1, 38: 1, 39: 1, 40: 1 };
  if (keys[e.keyCode]) {
    preventDefault(e);
    return false;
  }
  return true;
};

export const enableScroll = () => {
  if (window.removeEventListener)
    window.removeEventListener('DOMMouseScroll', preventDefault, false);
  window.onmousewheel = document.onmousewheel = null;
  window.onwheel = null;
  window.ontouchmove = null;
  document.onkeydown = null;
};

export const disableScroll = () => {
  if (window.addEventListener)
    window.addEventListener('DOMMouseScroll', preventDefault, false);
  window.onwheel = preventDefault; // modern standard
  window.onmousewheel = document.onmousewheel = preventDefault; // older browsers, IE
  // window.ontouchmove = preventDefault; // mobile
  document.onkeydown = preventDefaultForScrollKeys;
};

export const hasElementClass = (element, className) => {
  return element.classList
    ? element.classList.contains(className)
    : new RegExp(`(^| )${className}( |$)`, 'gi').test(element.className);
};
export const addElementClass = (element, className) => {
  element.classList
    ? element.classList.add(className)
    : (element.className += ` ${className}`);
};

export const removeElementClass = (element, className) => {
  element.classList
    ? element.classList.remove(className)
    : (element.className = element.className.replace(
        new RegExp(`(^|\\b)${className.split(' ').join('|')}(\\b|$)`, 'gi'),
        ' ',
      ));
};

const throttle = (delay, fn) => {
  let last, deferTimer;
  return () => {
    const context = this,
      args = arguments,
      now = +new Date();
    if (last && now < last + delay) {
      clearTimeout(deferTimer);
      deferTimer = setTimeout(() => {
        last = now;
        fn.apply(context, args);
      }, delay);
    } else {
      last = now;
      fn.apply(context, args);
    }
  };
};

export const removeScrollListener = () => {
  window.removeEventListener('scroll', throttle, false);
};

export const autoHideStickyHeader = elSelector => {
  const elClassHidden = 'header--hidden',
    throttleTimeout = 100,
    element = document.getElementById(elSelector);

  if (!element) return true;

  let dHeight = 0,
    wHeight = 0,
    wScrollCurrent = 0,
    wScrollBefore = 0,
    wScrollDiff = 0;

  window.addEventListener(
    'scroll',
    throttle(throttleTimeout, () => {
      dHeight = document.body.offsetHeight;
      wHeight = window.innerHeight;
      wScrollCurrent = window.pageYOffset;
      wScrollDiff = wScrollBefore - wScrollCurrent;

      if (wScrollCurrent <= 0) {
        // scrolled to the very top; element sticks to the top
        removeElementClass(element, elClassHidden);
      } else if (wScrollDiff > 25 && hasElementClass(element, elClassHidden)) {
        // scrolled up; element slides in
        removeElementClass(element, elClassHidden);
      } else if (wScrollDiff < 0) {
        // scrolled down
        if (
          wScrollCurrent + wHeight >= dHeight &&
          hasElementClass(element, elClassHidden)
        ) {
          // scrolled to the very bottom; element slides in
          // removeElementClass(element, elClassHidden);
        } else {
          // scrolled down; element slides out
          addElementClass(element, elClassHidden);
        }
      }
      wScrollBefore = wScrollCurrent;
    }),
    false,
  );
};

export const autoHideStickyNextPrev = elSelector => {
  const elClassHidden = 'nextPrev--hidden',
    throttleTimeout = 100,
    element = document.getElementById(elSelector);

  if (!element) return true;

  let dHeight = 0,
    wHeight = 0,
    wScrollCurrent = 0,
    wScrollBefore = 0,
    wScrollDiff = 0;

  window.addEventListener(
    'scroll',
    throttle(throttleTimeout, () => {
      dHeight = document.body.offsetHeight;
      wHeight = window.innerHeight;
      wScrollCurrent = window.pageYOffset;
      wScrollDiff = wScrollBefore - wScrollCurrent;

      if (wScrollCurrent <= 0) {
        // scrolled to the very top; element sticks to the top
        removeElementClass(element, elClassHidden);
      } else if (wScrollDiff > 25 && hasElementClass(element, elClassHidden)) {
        // scrolled up; element slides in
        removeElementClass(element, elClassHidden);
      } else if (wScrollDiff < 0) {
        // scrolled down
        if (
          wScrollCurrent + wHeight >= dHeight &&
          hasElementClass(element, elClassHidden)
        ) {
          // scrolled to the very bottom; element slides in
          // removeElementClass(element, elClassHidden);
        } else {
          // scrolled down; element slides out
          addElementClass(element, elClassHidden);
        }
      }
      wScrollBefore = wScrollCurrent;
    }),
    false,
  );
};

export const staticNavHidden = elSelector => {
  const elClassHidden = 'nextPrev--hidden',
    throttleTimeout = 100,
    element = document.getElementById(elSelector);

  if (!element) return true;

  let dHeight = 0,
    wHeight = 0,
    wScrollCurrent = 0,
    wScrollBefore = 0,
    wScrollDiff = 0;

  window.addEventListener(
    'scroll',
    throttle(throttleTimeout, () => {
      dHeight = document.body.offsetHeight;
      wHeight = window.innerHeight;
      wScrollCurrent = window.pageYOffset;
      wScrollDiff = wScrollBefore - wScrollCurrent;

      if (wScrollCurrent <= 0) {
        // scrolled to the very top; element sticks to the top
        removeElementClass(element, elClassHidden);
      } else if (wScrollDiff > 25 && hasElementClass(element, elClassHidden)) {
        // scrolled up; element slides in
        removeElementClass(element, elClassHidden);
      } else if (wScrollDiff < 0) {
        // scrolled down
        if (
          wScrollCurrent + wHeight >= dHeight &&
          hasElementClass(element, elClassHidden)
        ) {
          // scrolled to the very bottom; element slides in
          //removeElementClass(element, elClassHidden);
        } else {
          // scrolled down; element slides out
          addElementClass(element, elClassHidden);
        }
      }
      wScrollBefore = wScrollCurrent;
    }),
  );
};
